<template>
	<v-scale-screen width="1920" height="1080" :delay="100" :full-screen="false" class="content">
		<!-- <t-loading :loading="loading" size="large" text="数据加载中..." fullscreen /> -->
		<!-- <div id="animations">
			<div class="animation animation1">
				<div class="animate1"></div>
				<div class="animate2"></div>
				<div class="animate3"></div>
			</div>
			<div class="animation animation4">
				<div class="animate1"></div>
				<div class="animate2"></div>
				<div class="animate3"></div>
			</div>
			<div class="animation animation5 fanzhuan">
				<div class="animate1"></div>
				<div class="animate2"></div>
				<div class="animate3"></div>
			</div>
		</div> -->
		<div class="head clearfix">
			<div class="menu menu2 pulll_left">
				<h1 class="pulll_left">{{ '运营总览' }}</h1>
			</div>
			<div id="showTime" class="time">{{ currentTime }}</div>
		</div>
		<div class="mainbox">
			<div class="box1">
				<ul class="clearfix nav1">
					<li style="width: 422px">
						<dashboard-block-ranking ref="blockRanking"></dashboard-block-ranking>
						<dashboard-block-contrast ref="blockContrast"></dashboard-block-contrast>
					</li>
					<li style="width: 1068px">
						<dashboard-block-map ref="blockMap"></dashboard-block-map>
					</li>
					<li style="width: 422px">
						<dashboard-block-member-info ref="blockMemberInfo"></dashboard-block-member-info>
						<dashboard-block-charge-trend ref="blockChargeTrend"></dashboard-block-charge-trend>
					</li>
				</ul>
			</div>

			<div class="box box2" style="padding: 20px 0">
				<ul class="clearfix nav2">
					<li>
						<dashboard-block-status ref="blockStatus"></dashboard-block-status>
					</li>
					<li style="width: 948px">
						<dashboard-block-charge-cost ref="blockChargeCost"></dashboard-block-charge-cost>
					</li>
					<li>
						<dashboard-block-charge-way ref="blockChargeWay"></dashboard-block-charge-way>
					</li>
				</ul>
			</div>
		</div>
	</v-scale-screen>
</template>

<script>
	import webapi from '../../webapi';
	import tagcloud from './tagCloud.js';

	import VScaleScreen from 'v-scale-screen';
	import DashboardBlockChargeCost from './components/block-charge-cost.vue';
	import DashboardBlockChargeTrend from './components/block-charge-trend.vue';
	import DashboardBlockChargeWay from './components/block-charge-way.vue';
	import DashboardBlockContrast from './components/block-contrast.vue';
	import DashboardBlockMap from './components/block-map.vue';
	import DashboardBlockMemberInfo from './components/block-member-info.vue';
	import DashboardBlockRanking from './components/block-ranking.vue';
	import DashboardBlockStatus from './components/block-status.vue';

	export default {
		components: {
			VScaleScreen,
			DashboardBlockChargeCost,
			DashboardBlockChargeTrend,
			DashboardBlockChargeWay,
			DashboardBlockContrast,
			DashboardBlockMap,
			DashboardBlockMemberInfo,
			DashboardBlockRanking,
			DashboardBlockStatus,
		},
		data() {
			return {
				loading: false,
				currentTime: '',
			}
		},
		mounted() {
			this.loading = true;
			let t = null;
			t = setTimeout(time, 1000); //開始运行
			const _this = this;

			this.getData();
			
			setTimeout(() => {
				tagcloud({
					selector: '.tagcloud', // 元素选择器
					fontsize: 6, // 基本字体大小, 单位px
					radius: 75, // 滚动半径, 单位px 页面宽度和高度的五分之一
					mspeed: 'slow', // 滚动最大速度, 取值: slow, normal(默认), fast
					ispeed: 'slow', // 滚动初速度, 取值: slow, normal(默认), fast
					direction: 10, // 初始滚动方向, 取值角度(顺时针360): 0对应top, 90对应left, 135对应right-bottom(默认)...
					keep: false, // 鼠标移出组件后是否继续随鼠标滚动, 取值: false, true(默认) 对应 减速至初速度滚动, 随鼠标滚动
				});
			}, 1000);

			function time() {
				clearTimeout(t); //清除定时器
				const dt = new Date();
				const yyyy = dt.getFullYear().toString().padStart(2, '0');
				const MM = (dt.getMonth() + 1).toString().padStart(2, '0');
				const dd = dt.getDate().toString().padStart(2, '0');
				const HH = dt.getHours().toString().padStart(2, '0'); //获取时
				const mm = dt.getMinutes().toString().padStart(2, '0'); //获取分
				const ss = dt.getSeconds().toString().padStart(2, '0'); //获取秒
				// document.getElementById("showTime").innerHTML = yyyy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss + "";
				_this.currentTime = yyyy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss + "";
				t = setTimeout(time, 1000); //设定定时器，循环运行     
			}
		},
		methods: {
			getData() {
				this.$axios.post(webapi.base_api_url + "/Overview/GetDashboard").then((res) => {
					this.$refs.blockMap.setData(res.data.Data.StationsInfo, res.data.Data.RevenueSummary);
					this.$refs.blockStatus.setData(res.data.Data.StationsInfo);
					this.$refs.blockChargeCost.setData(res.data.Data.StatisticsFee);
					this.$refs.blockChargeTrend.setData(res.data.Data.ChargeTrendCurve);
					this.$refs.blockMemberInfo.setData(res.data.Data.MemberTrend);
					this.$refs.blockRanking.setData(res.data.Data.StationRanking);
					this.$refs.blockChargeWay.setData(res.data.Data.ChargeWays);
					this.$refs.blockContrast.setData(res.data.Data.ChargeContrast);

					this.loading = false; // 加载完成
				}).finally(() => {
					setTimeout(() => this.getData(), 6000000);
				});
			}
		}
	}
</script>

<style scoped>
	.screen-box {
		background: transparent !important;
		color: white;
	}
</style>